export const cuentasIngresos = [184, 189, 190, 317]
export const cuentasEgresos = [192, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217,
218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 239, 240, 241, 242]
export const existencias = [68, 69, 70]
export const activosFijos = [79, 82, 83, 86, 87, 88, 89, 90]
export const activosIntangibles = [104, 105]

export const TypesCuentas = Object.freeze({
    INGRESO: 'ingreso',
    EXISTENSIAS: 'existensias',
    ACTIVOSFIJOS: 'activos-fijos',
    ACTIVOSINTANGIBLES: 'activos-intangibles',
    GASTOS: 'gastos',
  })

export const getExpenseTypeKeyFromAccountCode = accountCode => {
  const normalizedCode = String(accountCode ?? '').trim().replace(/\s+/g, '')

  if (/^1-1-8(?:-|$)/.test(normalizedCode)) return TypesCuentas.EXISTENSIAS
  if (/^1-2-(?:1|3|4)(?:-|$)/.test(normalizedCode)) return TypesCuentas.ACTIVOSFIJOS
  if (/^1-3-2(?:-|$)/.test(normalizedCode)) return TypesCuentas.ACTIVOSINTANGIBLES
  if (
    (/^3-1-1(?:-|$)/.test(normalizedCode) || /^3-2-1(?:-|$)/.test(normalizedCode)) &&
    !['3-2-1-1', '3-2-1-2'].includes(normalizedCode)
  ) {
    return TypesCuentas.INGRESO
  }
  if (/^3-(?:1-2|2-[234])(?:-|$)/.test(normalizedCode)) return TypesCuentas.GASTOS

  return null
}
